import { ref, remove } from "firebase/database";
import { db } from "../firebaseConfig";

export const deleteCashMovement = async (movementId: string) => {
	try {
		const movementRef = ref(db, `cashMovements/${movementId}`);
		await remove(movementRef);
	} catch (error) {
		console.error("Error deleting cash movement:", error);
		throw error;
	}
};
